export enum NotificationStatus {
  new = 'new',
  watched = 'watched',
  deleted = 'deleted',
}
